import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

// Attach Authorization header from localStorage token + audit tenant header
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const audit = localStorage.getItem("audit_tenant_id");
  if (audit) config.headers["X-Audit-Tenant-Id"] = audit;
  return config;
});

// Bloque 6 — Interceptor global de 401: si el token expira, limpiamos sesión y volvemos a /login.
// Se evita un redirect loop verificando que NO estemos ya en /login y que la request no sea de auth.
let _redirectingTo401 = false;
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (status === 401 && !_redirectingTo401) {
      const isAuthCall = url.includes("/auth/login") || url.includes("/auth/me");
      const onLogin = typeof window !== "undefined" && window.location?.pathname === "/login";
      if (!isAuthCall && !onLogin) {
        _redirectingTo401 = true;
        try {
          localStorage.removeItem("token");
          localStorage.removeItem("audit_tenant_id");
        } catch (_) {}
        // Pequeño defer para que el toast pueda mostrarse si alguien escucha
        setTimeout(() => {
          if (typeof window !== "undefined") {
            // Hard reload a "/" para que AuthProvider re-fetchee y muestre Login.
            window.location.href = "/?session_expired=1";
          }
        }, 50);
      }
    }
    return Promise.reject(error);
  }
);

export function formatErr(detail) {
  if (detail == null) return "Algo salió mal";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" · ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
